import { Fit } from "@seneca/image-service-client";

import { Link } from "common/types/routing";

import { getDimensionFromCSSVar } from "seneca-common/utils/functions";

import { linkToSessionCreateSubscriptionJourney } from "features/classroom/routes/links";
import {
  makeLinkToWhatIsPremium,
  SUBSCRIPTION_JOURNEY_SOURCES
} from "features/dashboard/pages/what-is-premium-page/routes/links";
import { ModuleDeviceRequirements } from "features/module/types";

import styles from "./components/TextBlock.module.scss";

export const DEVICE_REQUIREMENTS: ModuleDeviceRequirements = {
  minModuleWidth: 300,
  desktopOnly: false
};

export const assetParameters = {
  default: {
    height: getDimensionFromCSSVar(styles.var_defaultImageHeight),
    width: getDimensionFromCSSVar(styles.var_defaultImageWidth),
    fit: Fit.COVER
  }
};

type InternalLinkOption = {
  value: string;
  label: string;
  link: (arg0: { courseId: string; sectionId: string }) => Link;
};
export const INTERNAL_LINK_OPTIONS: Array<InternalLinkOption> = [
  {
    value: "createSubscription",
    label: "Create subscription journey",
    link: ({ courseId, sectionId }) =>
      linkToSessionCreateSubscriptionJourney(courseId, sectionId) as any
  },
  {
    value: "whatIsPremium",
    label: "What is premium page",
    link: linkToWhatIsPremium
  }
];

function linkToWhatIsPremium() {
  return makeLinkToWhatIsPremium({
    source: SUBSCRIPTION_JOURNEY_SOURCES.SESSION
  });
}
